import './ReviewCard.css';

const ReviewCard = ({ image, text, author, className = "" }) => {
    const quote = require('../res/open-quote.avif');
    return (
        <div className={`review-card ${className}`}>
            <img className="review-img" src={image} alt="Sushi plate" />
            <img className="quote-icon" src={quote} alt="Open quote"/>
            <p className="text">{text}</p>
            <span className="divider" />
            <p className="author">{author}</p>
        </div>
    )
}

export default ReviewCard;